import React from 'react';
import PropTypes from "prop-types";

const TextField = ({ config }) => {
    config = Object.assign({}, textFieldDefaults(), config);

    if (!config.showLabel) {
        config.labelClass += " show-for-sr";
    }

    return (
        <div className={"grid-x " + config.wrapperClass}>
            <label className={"cell " + config.labelClass} htmlFor={config.name}>{ (config.isRequired) && <span className="text-danger">* </span>}{config.label}</label>
            <div className={"cell " + config.inputClass}>
                <input type={config.inputType}
                       name={config.name}
                       id={config.name}
                       placeholder={config.placeholder}
                       value={config.value}
                       onChange={f => f}
                       disabled={config.disabled}
                       maxLength={config.maxLength}
                       tabIndex={config.tabIndex}
                />
            </div>

            {config.error && <div className="text-danger">{config.error}</div>}
        </div>
    );
};

TextField.propTypes = {
    config: PropTypes.shape({
        inputType: PropTypes.string,
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        value: PropTypes.string.isRequired,
        showLabel: PropTypes.bool.isRequired,
        error: PropTypes.string,

        wrapperClass: PropTypes.string,
        labelClass: PropTypes.string,
        inputClass: PropTypes.string,
        disabled: PropTypes.bool,
        maxLength: PropTypes.number.isRequired,
        isRequired: PropTypes.bool,
        tabIndex: PropTypes.number
    })
};

function textFieldDefaults() {
    return {
        inputType: "text",
        wrapperClass: "",
        disabled: false,
        labelClass: "small-12",
        inputClass: "small-12",
        isRequired: false
    };
}

export default TextField;